import { Dispatch, SetStateAction } from 'react';

import { message as AntdMessage } from 'antd';

import { DossierDtoAdminFonctionnel } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';

function removePieceJointeFromDossierDto(
  dossierAdmin: DossierDtoAdminFonctionnel,
  identifiant: string,
): DossierDtoAdminFonctionnel {
  const source = dossierAdmin.listAvailablePiecesJointes;
  return {
    ...dossierAdmin,
    listAvailablePiecesJointes: source
      ? source.filter(source => source.identifiant !== identifiant)
      : null,
  };
}

export function useDeletePieceJointe(
  setDeleting: Dispatch<SetStateAction<boolean>>,
  dossierAdmin: DossierDtoAdminFonctionnel,
  setDossier: (dossier: DossierDtoAdminFonctionnel) => void,
  closeModal: () => void,
  refetchEvents: () => Promise<void>,
): (identifiant: string) => Promise<void> {
  const controllerPieceJointeApi = useApi().PieceJointeControllerApi;

  return async identifiant => {
    setDeleting(true);
    await controllerPieceJointeApi
      .deletePieceJointeUsingDELETE(dossierAdmin.id, identifiant)
      .then(() => {
        setDossier(removePieceJointeFromDossierDto(dossierAdmin, identifiant));
        void AntdMessage.success('Pièce jointe supprimée avec succès');
      })
      .then(refetchEvents)
      .then(closeModal)
      .catch(() => {
        void AntdMessage.error(
          'Erreur lors de la suppression de la pièce jointe',
        );
      })
      .finally(() => {
        setDeleting(false);
      });
  };
}
